import { SalesInsightsGoalScope } from '../models/sales-insights.model';

export interface SalesInsightsGoalScopeForm {
  salesperson: string[];
  country: string[];
  dimensions: { [name: string]: string[] };
  visitRequiredOnly: boolean;
  flags: string[];
  includeCustomerIds: string[];
  excludeCustomerIds: string[];
}

// Older goals may hold a single text where the backend now keeps a list.
export function salesInsightsGoalScopeList(value: string | string[] | null | undefined): string[] {
  if (Array.isArray(value)) {
    return value.filter(item => !!item);
  }
  return value ? [value] : [];
}

export function salesInsightsGoalScopeForm(scope: SalesInsightsGoalScope | null | undefined): SalesInsightsGoalScopeForm {
  const dimensions: { [name: string]: string[] } = {};
  Object.entries(scope?.dimensions || {}).forEach(([name, values]) => {
    const list = salesInsightsGoalScopeList(values);
    if (list.length) {
      dimensions[name] = list;
    }
  });
  return {
    salesperson: salesInsightsGoalScopeList(scope?.salesperson),
    country: salesInsightsGoalScopeList(scope?.country),
    dimensions,
    visitRequiredOnly: !!scope?.visitRequiredOnly,
    flags: salesInsightsGoalScopeList(scope?.flags),
    includeCustomerIds: salesInsightsGoalScopeList(scope?.includeCustomerIds),
    excludeCustomerIds: salesInsightsGoalScopeList(scope?.excludeCustomerIds)
  };
}

export function salesInsightsGoalScopeInput(form: SalesInsightsGoalScopeForm): SalesInsightsGoalScope {
  const dimensions: { [name: string]: string[] } = {};
  Object.entries(form.dimensions).forEach(([name, values]) => {
    if (values?.length) {
      dimensions[name] = [...values];
    }
  });
  return {
    salesperson: [...form.salesperson],
    country: [...form.country],
    dimensions,
    visitRequiredOnly: form.visitRequiredOnly,
    flags: [...form.flags],
    includeCustomerIds: [...form.includeCustomerIds],
    excludeCustomerIds: [...form.excludeCustomerIds]
  };
}

export function salesInsightsGoalPick(form: SalesInsightsGoalScopeForm, customerId: string): void {
  form.excludeCustomerIds = form.excludeCustomerIds.filter(id => id !== customerId);
  if (!form.includeCustomerIds.includes(customerId)) {
    form.includeCustomerIds = [...form.includeCustomerIds, customerId];
  }
}

// A picked customer is only unpicked; one that is in through the conditions is excluded.
export function salesInsightsGoalDrop(form: SalesInsightsGoalScopeForm, customerId: string): void {
  if (form.includeCustomerIds.includes(customerId)) {
    form.includeCustomerIds = form.includeCustomerIds.filter(id => id !== customerId);
    return;
  }
  if (!form.excludeCustomerIds.includes(customerId)) {
    form.excludeCustomerIds = [...form.excludeCustomerIds, customerId];
  }
}

export function salesInsightsGoalRestore(form: SalesInsightsGoalScopeForm, customerId: string): void {
  form.excludeCustomerIds = form.excludeCustomerIds.filter(id => id !== customerId);
}
